import { Valence } from '@upright/common/model/types';
import {
  BoxLayoutOptions,
  equalInfoBoxesLayoutForSide,
} from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/info-boxes/equal-info-boxes-layout-for-side';
import { Bounds, CarouselLayout, Side } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';

interface BoxDatum {
  valence: Valence;
}

interface Layout {
  boxArea: (index: number, valence: Valence) => Bounds;
}

export function equalInfoBoxesLayout(
  baseLayout: CarouselLayout,
  data: BoxDatum[],
  lensIndex: number,
  previousLensIndex: number | undefined,
  options: BoxLayoutOptions,
): Layout {
  const countLeft = data.filter(d => d.valence === Valence.NEGATIVE).length;
  const countRight = data.filter(d => d.valence === Valence.POSITIVE).length;

  const ll = equalInfoBoxesLayoutForSide(baseLayout, Side.LEFT, countLeft, lensIndex, previousLensIndex, options);
  const lr = equalInfoBoxesLayoutForSide(baseLayout, Side.RIGHT, countRight, lensIndex, previousLensIndex, options);

  function boxArea(index: number, valence: Valence) {
    const layout = valence === Valence.NEGATIVE ? ll : lr;
    return layout.boxArea(index, false);
  }

  return { boxArea };
}
